export const RateValidate = (rule, value, cb) => {
  if (value === '' || value === undefined || value === 0) {
    cb(new Error('请给该问题选择评分'))
  }
  cb()
}